// TEKLİF GÖRÜNEN BİRİM KURALLARI — saf mantık (TEK KAYNAK)
// 05.11 kullanıcı isteği: Tül & Fon'da görünen birim "mtül" olsun (dikişteki
// gibi). HESAPLAMA DEĞİŞMEZ — yalnız etiket.

/**
 * Gerçek Tül & Fon kalemi mi? (m² ile fiyatlanan ama tül/fon OLMAYAN
 * ürünler — stor, plise — m²'ye devam eder.)
 * @param {object|null} it
 * @returns {boolean}
 */
export function isTulFonItem(it) {
  if (!it) return false;
  if (it.isTulFon === true) return true;
  const slug = String(it.groupSlug || "").toLowerCase();
  return slug.includes("tul_fon") || slug.includes("tulfon");
}

/**
 * MİKTAR sütununda görünen birim etiketi.
 * @param {boolean} tulFon
 * @returns {string} "mtül" | "m²"
 */
export function qtyUnitLabel(tulFon) {
  return tulFon ? "mtül" : "m²";
}
